<script>
    import { getContext } from 'svelte';
    import ShareNote from './popups/ShareNote/container.svelte';
    import ShareNoteForm from './popups/ShareNote/content.svelte';
    export let postUid;
  
    const { open, close } = getContext('simple-modal');
    const showPopup = () => {
          open(ShareNote,
            {
                message: "Share note",
            },
            {
                // closeButton: CloseButton,
                form: ShareNoteForm,
                propsForForm: [postUid],
                // styleWindow: {

                // }
            }
        );
      };
</script>

<button 
    class="new-subscription-button primary-green" 
    on:click={showPopup}>
        share
</button>